/**
 * O texto da recusa do conector gov.br, escrito uma vez para os DOIS caminhos que
 * levam a ela.
 *
 * Caminho 1 — `SemAcessoAoConector` (em `ConectorGovBrPage.tsx`): a tela sabe pelo `useAuth`, antes de
 * qualquer requisição, que o usuário não tem `ADMIN` (contrato.ts,
 * `podeVerConector`). Recusa na hora, sem ida à rede.
 *
 * Caminho 2 — `EstadoDaTela` (`@/ui/EstadoDaTela`) com erro 403 e
 * `recusa={RECUSA_DO_CONECTOR}`: a busca saiu e a API recusou. Acontece quando o
 * papel muda no meio da sessão, ou quando o token que a tela leu não é o que a
 * API leu.
 *
 * Os dois existem de propósito, e nenhum substitui o outro: o primeiro evita
 * requisição inútil e a piscada de esqueleto; o segundo cobre o que o primeiro
 * não tem como prever. O que eles NÃO podem fazer é falar diferente sobre a
 * mesma situação — daí o texto ser uma constante, e não dois textos parecidos.
 *
 * E o que nenhum dos dois pode virar é estado vazio. "Não há nada aqui" seria
 * mentira: há, e quem está olhando é que não alcança.
 */

import { AREA_ADMIN } from '@/nucleo/navegacao/mapa';
import { type RecusaPropria } from '@/ui/EstadoDaTela';

export const RECUSA_DO_CONECTOR: RecusaPropria = {
  titulo: 'O conector gov.br é restrito ao administrador do sistema',
  descricao:
    'A área de administração aceita mais de um perfil, mas esta tela abre apenas para quem é ' +
    'administrador do sistema. Para ver ou alterar a integração com o gov.br, fale com um ' +
    'administrador do sistema.',
  // Sem "tentar de novo": a resposta seria a mesma, e a pessoa ficaria batendo
  // na porta. O caminho útil é voltar para o que ela alcança.
  acao: { label: 'Voltar para a administração', to: AREA_ADMIN.raiz },
};
